/**
 * Voce Wiki — Layer 3 knowledge community article. Distinct from Documento di Policy:
 * policy = official rule; wiki entry = shared domain know-how. No acceptance.
 * Versioning (ADR-003): fork→promote creates a new Bozza row linked via parent_ref;
 * a Pubblicato voce is never overwritten in place.
 * Source: Marko spec §12. coreBOS-A: existing CMS/wiki with structured scoping + community voting.
 *
 * Scoped to one unità_organizzativa (+ optional funzione + lingua).
 * Publishable by non-IT function referents — no IT involvement required.
 * `utilita` is calcolato — sum of community votes (not stored here, projection).
 * States: Bozza → Pubblicato → Archiviato.
 * AI-Club wiki: RBAC restricts to the right area.
 */
export const wikiEntryDescriptor = {
    slug: 'wiki_entry',
    kind: 'document',
    label: { singular: 'Voce Wiki', plural: 'Voci Wiki' },
    table: 'ai_portal_wiki_entry',
    idStrategy: 'sha256',
    fields: [
        { name: 'titolo', type: 'text', label: 'Titolo', required: true },
        { name: 'corpo', type: 'text', label: 'Corpo (HTML)', required: true },
        { name: 'unita_organizzativa', type: 'text', label: 'Unità organizzativa', required: true },
        { name: 'funzione', type: 'text', label: 'Funzione' },
        { name: 'lingua', type: 'text', label: 'Lingua', required: true }, // Italiano | Inglese
        { name: 'stato', type: 'text', label: 'Stato', required: true },
        // Bozza | Pubblicato | Archiviato
        { name: 'utilita', type: 'number', label: 'Utilità (voti community)' }, // calcolato
        // Agent-spine facet (ADR-003): NULL for human-authored voci; set to the FK
        // KnowledgeType (lesson | decision | ...) when ingested from a producer client.
        { name: 'tipo', type: 'text', label: 'Tipo (knowledge facet)' },
        // Versioning (ADR-003): fork→promote lineage. `versione` defaults '1' on first
        // push; `parent_ref` holds the source id/wsid when a voce is forked from another.
        { name: 'versione', type: 'text', label: 'Versione' },
        { name: 'parent_ref', type: 'text', label: 'Parent ref' },
    ],
    relations: [
        { name: 'autore', kind: 'belongsTo', target: 'ai_user' },
    ],
    behaviors: {
        ownership: true,
        audit: true,
        documents: true,
        tenantScoped: true,
    },
    emits: ['wiki_entry.published'],
    ui: { mode: 'generated', icon: 'BookOutlined', navGroup: 'Formazione', navOrder: 31 },
};
